// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6959":"28799010","9782":"d46f857e"}[chunkId] + ".chunk.css";
};